export default __webpack_public_path__ + "static/media/Emotional02.c637cbac.png";